export default __webpack_public_path__ + "emptyDashboard.svg";